import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
const schedule = [{
  day: 'Lunes',
  hours: '10:00 a.m. – 3:00 p.m.'
}, {
  day: 'Martes',
  hours: '10:00 a.m. – 3:00 p.m.'
}, {
  day: 'Miércoles',
  hours: '10:00 a.m. – 3:00 p.m.'
}, {
  day: 'Jueves',
  hours: '10:00 a.m. – 3:00 p.m.'
}, {
  day: 'Viernes',
  hours: '10:00 a.m. – 3:00 p.m.'
}, {
  day: 'Sábado',
  hours: 'Cerrado',
  closed: true
}, {
  day: 'Domingo',
  hours: 'Cerrado',
  closed: true
}];
export function Hours() {
  return <section className="py-20 bg-cream-alt" data-id="element-101">
      <div className="max-w-3xl mx-auto px-6" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-cream rounded-3xl shadow-md border-t-8 border-coral p-8 md:p-12 relative overflow-hidden" data-id="element-103">
          <div className="absolute top-0 right-0 p-8 opacity-5 text-coral" data-id="element-104">
            <Clock size={120} data-id="element-105" />
          </div>

          <div className="relative z-10" data-id="element-106">
            <div className="flex items-center justify-center gap-3 mb-8" data-id="element-107">
              <Clock className="text-orange" size={28} data-id="element-108" />
              <h2 className="font-display text-3xl md:text-4xl font-bold text-coral" data-id="element-109">
                HORARIO
              </h2>
            </div>

            <div className="space-y-4" data-id="element-110">
              {schedule.map((item, idx) => <div key={item.day} className={`flex justify-between items-center py-3 border-b border-burgundy/10 last:border-0 ${item.closed ? 'text-charcoal/40' : 'text-charcoal'}`} data-id="element-111">
                  <span className="font-bold text-lg" data-id="element-112">{item.day}</span>
                  <span className={`text-lg ${item.closed ? 'italic' : 'font-medium'}`} data-id="element-113">
                    {item.hours}
                  </span>
                </div>)}
            </div>

            <div className="mt-8 text-center" data-id="element-114">
              <p className="text-charcoal/50 italic text-sm" data-id="element-115">
                * Holiday hours may vary.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}